
import { Component, Vue } from "vue-property-decorator";
import PortalServicios from "@/components/Tramites/PortalServicios.vue";

@Component({
  components: {
    PortalServicios
  }
})
export default class PortalServiciosView extends Vue {}
